<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false">
    <div :id="id"
         :aria-labelledby="id+'-title'"
         :data-id="name"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="form-group">
                <label class="font-weight-normal"
                       for="microorganismName">Nombre (Género y especie)</label>
                <input id="microorganismName"
                       v-model="microorganismName"
                       class="form-control"
                       name="microorganismName"
                       placeholder="Especifique el nombre del microorganismo."
                       type="text">
              </div>
              <div class="form-group">
                <label class="font-weight-normal"
                       for="microorganismEffects">Efectos sobre la salud</label>
                <textarea id="microorganismEffects"
                          v-model="microorganismEffects"
                          class="form-control"
                          name="microorganismEffects"
                          placeholder="Especifique los efectos sobre la salud."
                          rows="3"
                          type="text"></textarea>
              </div>
              <div class="form-group">
                <label class="font-weight-normal"
                       for="microorganismRiskLevels">Nivel de riesgo (OMS)</label>
                <textarea id="microorganismRiskLevels"
                          v-model="microorganismRiskLevels"
                          class="form-control"
                          name="microorganismRiskLevels"
                          placeholder="Especifique el nivel de riesgo."
                          rows="3"
                          type="text"></textarea>
              </div>
              <div class="form-group">
                <label class="font-weight-normal"
                       for="microorganismRoutes">Rutas naturales de entrada del microorganismo al hospedero
                                                 susceptible</label>
                <textarea id="microorganismRoutes"
                          v-model="microorganismRoutes"
                          class="form-control"
                          name="microorganismRoutes"
                          placeholder="Especifique las ruta naturales de entrada."
                          rows="3"
                          type="text"></textarea>
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button :disabled="addingMicroorganism"
                    class="btn btn-primary mr-2"
                    type="submit">
              <template v-if="!addingMicroorganism">
                {{ index !== null ? 'Editar' : 'Agregar' }}
              </template>
              <span v-if="addingMicroorganism"
                    class="spinner-border text-yellow-500 spinner-border-sm"
                    role="status">
                <span class="sr-only">
                  {{ index !== null ? 'Editando...' : 'Agregando...' }}
                </span>
              </span>
            </button>
            
            <button :disabled="addingMicroorganism"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    @click="clearForm">Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import 'jquery-validation'
  import { AlertManager } from '../../../utils/AlertManager'
  
  export default {
    name: 'MicroorganismsModal',
    components: {},
    props: {
      title: {
        default: 'Agregar microorganismo',
      },
      id: {
        default: 'microorganisms-modal',
      },
      name: {
        default: 'microorganisms-modal',
      },
    },
    data () {
      return {
        addingMicroorganism: false,
        microorganismName: '',
        microorganismEffects: '',
        microorganismRiskLevels: '',
        microorganismRoutes: '',
        index: null,
      }
    },
    methods: {
      clearForm () {
        this.microorganismName       = ''
        this.microorganismEffects    = ''
        this.microorganismRiskLevels = ''
        this.microorganismRoutes     = ''
        this.index                   = null
      },
      async addMicroorganism () {
        const microorganism = {
          name: this.microorganismName,
          effects: this.microorganismEffects,
          riskLevels: this.microorganismRiskLevels,
          routes: this.microorganismRoutes,
        }
        
        this.$emit('add-microorganism', microorganism)
        
        this.clearForm()
        
        AlertManager.success('Microorganismo agregado correctamente')
      },
      editMicroorganism (index, microorganism) {
        this.microorganismName = microorganism.name
        this.microorganismEffects = microorganism.effects
        this.microorganismRiskLevels = microorganism.riskLevels
        this.microorganismRoutes = microorganism.routes
        this.index = index
      },
      async updateMicroorganism () {
        const microorganism = {
          name: this.microorganismName,
          effects: this.microorganismEffects,
          riskLevels: this.microorganismRiskLevels,
          routes: this.microorganismRoutes,
        }
        
        this.$emit('update-microorganism', this.index, microorganism)
        
        this.clearForm()
        
        AlertManager.success('Microorganismo editado correctamente')
      },
    },
    mounted () {
      const vm = this
      
      /**
       * Init JQuery validation
       */
      $(() => {
        
        $('#frm-' + this.id).validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.insertAfter(element)
            label.addClass('invalid-feedback')
          },
          rules: {
            microorganismName: {
              required: true,
            },
            microorganismEffects: {
              required: true,
            },
            microorganismRiskLevels: {
              required: true,
            },
            microorganismRoutes: {
              required: true,
            },
          },
          messages: {
            microorganismName: {
              required: 'Este campo es requerido.',
            },
            microorganismEffects: {
              required: 'Este campo es requerido.',
            },
            microorganismRiskLevels: {
              required: 'Este campo es requerido.',
            },
            microorganismRoutes: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            if (vm.index !== null) {
              vm.updateMicroorganism()
            }
            else {
              vm.addMicroorganism()
            }
          },
        })
      })
    },
  }
</script>
